import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useEffectOnce } from "react-use";

import { useEpBillingAccount } from "@/hooks/use_ep_billing_account";
import { useEpPageconfigListRecursive } from "@/hooks/use_ep_pageconfig";
import { useEpUsersMe } from "@/hooks/use_ep_users_me";

import { useContextApp } from "../app";
import { IWindowMessage } from "./wm.types";

export const ProviderWindowMessage = () => {
  const {
    actions: { organizationIdChange },
  } = useContextApp();

  const { accountInvalidate } = useEpBillingAccount();

  const { meUpdatePartial } = useEpUsersMe();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  useEffectOnce(() => {
    window.onmessage = (event: MessageEvent | any) => {
      const message: IWindowMessage = event.data;
      switch (message.event) {
        case "window.close":
          const source = event.source;
          source && source.close && source.close();
          break;
        case "history.push":
          navigate(message.data.path);
          break;
        case "post_list_variant_change":
          meUpdatePartial({
            settings: {
              ui: {
                post_list_variant: message.data.variant,
              },
            },
          });
          break;
        case "post_update_scheduled":
          accountInvalidate();
          queryClient.invalidateQueries(useEpPageconfigListRecursive.KEY, {
            refetchInactive: true,
          });
          break;
        case "legacy_switch_organization_context":
          organizationIdChange({
            organizationId: message.data.organizationId,
          });
          break;
        case "window.open":
          if (message.data.target === "_blank") {
            navigate("/billing/waiting");
          }
          window.open(message.data.uri, message.data.target || "_self");
          break;
      }
    };
  });

  return null;
};
